<template>
    <section class="section pesquisa-itens-page">
        <div class="pesquisa-itens-header">
            <div>
                <router-link :to="{ name: 'pesquisar' }" class="pesquisa-voltar"><b-icon icon="arrow-left" size="is-small" /> Voltar para Pesquisar</router-link>
                <h1 class="title is-3">Pesquisa de itens</h1>
                <p>Valores unitários comerciais dos itens nas versões vigentes dos orçamentos.</p>
            </div>
        </div>

        <form class="box pesquisa-itens-filtros" @submit.prevent="pesquisar">
            <b-field label="Peça ou serviço" expanded>
                <b-input v-model.trim="descricao" icon="magnify" placeholder="Descrição do item" maxlength="100" required />
            </b-field>
            <b-field label="Cliente" expanded>
                <b-input v-model.trim="cliente" icon="account-outline" placeholder="Nome do cliente (opcional)" maxlength="100" />
            </b-field>
            <b-button native-type="submit" type="is-primary" icon-left="magnify">Buscar</b-button>
        </form>

        <div class="box pesquisa-itens-resultado">
            <div class="pesquisa-itens-resumo"><h2 class="title is-5">Itens encontrados</h2><b-tag rounded>{{ resultado.total }} resultados</b-tag></div>
            <b-table :data="resultado.itens || []" :loading="carregando" paginated backend-pagination
                :total="resultado.total" :per-page="20" :current-page.sync="pagina" mobile-cards hoverable
                @page-change="buscar" empty-message="Nenhum item encontrado com estes filtros.">
                <b-table-column field="descricao" label="Peça / serviço" v-slot="p">
                    <strong>{{ p.row.descricao }}</strong>
                    <small class="is-block has-text-grey">{{ p.row.quantidade }} {{ p.row.unidadeMedida || 'un.' }}</small>
                </b-table-column>
                <b-table-column field="clienteNome" label="Cliente" v-slot="p">{{ p.row.clienteNome }}</b-table-column>
                <b-table-column field="numeroOrcamento" label="Orçamento" v-slot="p">
                    <router-link :to="{ name: 'prd-orcamento', params: { id: p.row.orcamentoId } }">Nº {{ p.row.numeroOrcamento }}</router-link>
                    <small class="is-block has-text-grey">{{ data(p.row.dataHoraCadastro) }}</small>
                </b-table-column>
                <b-table-column field="status" label="Status" v-slot="p"><prd-status-tag :status="p.row.status" tipo="orcamento" /></b-table-column>
                <b-table-column field="valorUnitarioComercial" label="Valor unitário" numeric v-slot="p">
                    <strong>{{ p.row.valorUnitarioComercial == null ? '—' : moeda(p.row.valorUnitarioComercial) }}</strong>
                </b-table-column>
            </b-table>
        </div>
    </section>
</template>

<script>
import http from '@/http'
import { mapState } from 'vuex'
import prdStatusTag from '@/components/prd/prdStatusTag.vue'

export default {
    name: 'PesquisarItens',
    components: { prdStatusTag },
    data() {
        return {
            descricao: String(this.$route.query.descricao || ''),
            cliente: String(this.$route.query.cliente || ''),
            pagina: 1,
            carregando: false,
            resultado: { itens: [], total: 0 },
        }
    },
    computed: { ...mapState(['unidadeId']) },
    watch: { unidadeId: 'pesquisar' },
    created() { this.buscar(1) },
    methods: {
        pesquisar() {
            if (!this.descricao) {
                this.resultado = { itens: [], total: 0 }
                return
            }
            if (this.$route.query.descricao !== this.descricao || this.$route.query.cliente !== this.cliente)
                this.$router.replace({ name: 'pesquisar-itens', query: { descricao: this.descricao, cliente: this.cliente } })
            this.buscar(1)
        },
        async buscar(pagina) {
            if (!this.unidadeId || !this.descricao) return
            this.pagina = pagina || 1
            this.carregando = true
            try {
                const resposta = await http.get('/api/prd/orcamentos/itens/pesquisa', {
                    params: { unidadeId: this.unidadeId, descricao: this.descricao, cliente: this.cliente, pagina: this.pagina, porPagina: 20 },
                })
                this.resultado = resposta.data
            } catch (erro) {
                this.resultado = { itens: [], total: 0 }
                this.erro(erro)
            } finally {
                this.carregando = false
            }
        },
        moeda(valor) { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(valor) || 0) },
        data(valor) { return valor ? this.$moment(valor).format('DD/MM/YYYY') : '' },
    },
}
</script>

<style scoped>
.pesquisa-itens-page { max-width: 1280px; margin: 0 auto; }
.pesquisa-itens-header { margin-bottom: 1.5rem; }
.pesquisa-itens-header .title { margin: .6rem 0 .3rem; color: #263c31; }
.pesquisa-itens-header p { color: #687a70; }
.pesquisa-voltar { display: inline-flex; align-items: center; gap: .2rem; color: #21825b; font-size: .9rem; }
.pesquisa-itens-filtros { display: flex; align-items: flex-end; gap: 1rem; border: 1px solid #e2eae5; border-radius: 16px; }
.pesquisa-itens-filtros .field { flex: 1; }
.pesquisa-itens-filtros .button { margin-bottom: .75rem; }
.pesquisa-itens-resultado { padding: 0; overflow: hidden; border: 1px solid #e2eae5; border-radius: 16px; }
.pesquisa-itens-resumo { display: flex; align-items: center; justify-content: space-between; padding: 1.2rem 1.4rem; border-bottom: 1px solid #edf1ef; }
.pesquisa-itens-resumo .title { margin: 0; }
@media (max-width: 768px) { .pesquisa-itens-filtros { display: block; } .pesquisa-itens-filtros .button { width: 100%; margin: .5rem 0 0; } }
</style>
